/**
 * Lightweight module-level tracker for the last item card the user hovered.
 * Using a plain mutable variable (not React state) so hover events don't
 * cause any re-renders.
 */
let _lastHoveredItemId: number | null = null;

export function setLastHoveredItemId(id: number): void {
  _lastHoveredItemId = id;
}

/** Returns the last hovered item ID and clears the stored value. */
export function getAndClearLastHoveredItemId(): number | null {
  const id = _lastHoveredItemId;
  _lastHoveredItemId = null;
  return id;
}
